import * as React from "react";
const IconQuarterAlt = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32 2C15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30S48.5 2 32 2m0 58C16.6 60 4 47.4 4 32S16.6 4 32 4s28 12.6 28 28-12.6 28-28 28" />
    <path d="M32 16c-8.8 0-16 7.2-16 16 0 .6.4 1 1 1h15c.6 0 1-.4 1-1V17c0-.6-.4-1-1-1m-1 15H18c.5-6.9 6.1-12.5 13-13z" />
  </svg>
);
export default IconQuarterAlt;
